module.exports = __webpack_public_path__ + "static/media/pic2Correct.59402618.mp3";